import React from 'react';
import { IconTypes } from '@shared/ui/atoms/icon/Icon';
import IconButton from '@shared/ui/molecules/icon-button/IconButton';
import styled from "styled-components";
import Colours from '@shared/ui/atoms/Colours';
import { BodyRegular } from '@shared/ui/atoms/fonts/Body';

interface Props {
  onClick: () => void;
  isOpen: boolean;
}

export default function SidebarToggleButton({ onClick, isOpen }: Props) {
  return (
    <Container $isOpen={isOpen}>
      <Wrapper>
        <ToggleButton onClick={onClick}
                      icon={isOpen ? IconTypes.Next : IconTypes.Previous}
                      $isOpen={isOpen}
                      color={isOpen ? 'black' : 'white'}  />
        {!isOpen && <BodyRegular weight={600}>Menu</BodyRegular>}
      </Wrapper>
    </Container>
  );
}

const Container = styled.div<{ $isOpen: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: ${props => props.$isOpen ? 'flex-start' : 'flex-end'};
  justify-content: ${props => props.$isOpen ? 'flex-end' : 'flex-start'};
`

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const ToggleButton = styled(IconButton)<{ $isOpen: boolean }>`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  overflow: hidden;
  background: ${props => props.$isOpen ? Colours.lightGrey : Colours.blue};
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin: 12px 12px 8px 12px;
  padding: 0;
  &:hover {
    background: ${props => props.$isOpen ? Colours.mildGrey : Colours.darkBlue};
  }
`;
